/* global google */
/* eslint no-undef: "error" */
import theme from '../theme.json';
import rlxMapStyles from './rlxMapStyles';

function initMap($map) {
    const mapLatitude = $map.attr('data-map-lat');
    const mapLongitude = $map.attr('data-map-lng');
    const storeIcon = {
        url: '/themes/Frontend/Wempe/frontend/_public/src/img/rolex-v7/icons/rlx-v7-store.svg',
        scaledSize: new google.maps.Size(36, 42),
        size: new google.maps.Size(36, 42),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 21),
    };

    const storePosition = { lat: Number(mapLatitude), lng: Number(mapLongitude) };

    const storeMap = new google.maps.Map($map[0], {
        zoom: 15,
        draggable: false,
        disableDefaultUI: true,
        center: storePosition,
        styles: theme,
    });

    storeMap.setOptions({
        styles: rlxMapStyles(),
    });

    /* eslint-disable no-unused-vars */
    const marker = new google.maps.Marker({
        position: storePosition,
        map: storeMap,
        optimized: false,
        icon: storeIcon,
    });
}

export default function rlxStoreMap() {
    const isLoadedAttr = 'data-gmaps-is-loaded';
    const isInitialisedAttr = 'data-is-initialised';
    const $map = $('.js_store-map').not(`[${isInitialisedAttr}]`);

    if (!$map.length) return;

    $map.attr(isInitialisedAttr, true);

    if (document.body.hasAttribute(isLoadedAttr)) {
        initMap($map);
        return;
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                initMap($map);
            }
        });
    });

    observer.observe(document.body, { attributeFilter: [isLoadedAttr] });
}
